<template>
  <div class="standard-page text-center">
    <AuthOverlay>
      <template #header>
        <GradientHeading>Register</GradientHeading>
      </template>
      <h3>{{ organization_name }}</h3>
      <div v-if="!success">
        <p>You've been invited join to the team!</p>
        <b-form @submit.prevent="handleSubmit">
          <b-form-group>
            <b-form-input v-model="email" disabled type="email" />
          </b-form-group>

          <b-form-group>
            <b-form-input
              v-model="password"
              type="password"
              placeholder="Password"
            />
          </b-form-group>

          <b-form-group>
            <b-form-input
              v-model="password2"
              type="password"
              placeholder="Confirm Password"
            />
          </b-form-group>

          <b-button pill variant="outline-primary" type="submit">
            Register
          </b-button>

          <div class="errors">
            <div v-for="error in errorList" :key="error" class="error">
              {{ error }}
            </div>
          </div>
        </b-form>
      </div>
      <div v-else>
        <p>
          You have successfully registered! <br />
          Please Login to continue.
        </p>
        <b-button :to="{ name: 'Login' }">Go To Login</b-button>
      </div>
    </AuthOverlay>
  </div>
</template>

<script>
import AuthOverlay from '@/components/Authentication/AuthOverlay/AuthOverlay.vue'
import GradientHeading from '@/components/Elements/GradientHeading/GradientHeading.vue'
import endpoints from '@/utils/endpoints.js'
import { anonymousAxios } from '@/utils/init-axios.js'

export default {
  components: { AuthOverlay, GradientHeading },
  data() {
    return {
      password: '',
      password2: '',
      errors: {},
      success: false,
      email: '',
      organization_name: ''
    }
  },
  mounted() {
    this.getInviteInfo()
  },
  methods: {
    handleSubmit() {
      this.errors = {}
      const payload = {
        password: this.password,
        confirm_password: this.password2,
        id: this.$route.params.id,
        token: this.$route.params.token
      }

      anonymousAxios
        .put(endpoints.listInvites(), payload)
        .then(res => {
          this.success = true
        })
        .catch(err => {
          console.log(err)
        })
    },
    getInviteInfo() {
      const params = {
        id: this.$route.params.id,
        token: this.$route.params.token
      }

      anonymousAxios
        .get(endpoints.listInvites(), { params })
        .then(res => {
          this.email = res.data.email
          this.organization_name = res.data.organization
        })
        .catch(err => console.log(err))
    }
  },
  computed: {
    errorList() {
      return Object.entries(this.errors).map(([key, value]) => {
        if (Array.isArray(value)) {
          return `${key}: ${value[0]}`
        } else {
          return value
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.errors {
  margin-top: 20px;
  color: $danger;
}

.error {
  &:first-letter {
    text-transform: capitalize;
  }
}

.logo {
  padding: 0 20px 20px;
  img {
    object-fit: contain;
    max-height: 200px;
  }
}
</style>
